export default __webpack_public_path__ + "static/media/AUDIOVISUAL.af03ae55.jpg";